export default __webpack_public_path__ + "static/media/FAQs.4fb48b7c.svg";